class Comprobante{
    constructor(id, tipo, numero, cliente_tipo_doc, cliente_num_doc, fecha, importe_total, importe_neto, importe_iva, comprobante_asociado, cae, vencimiento_cae, resultado, pedido, cliente, detalles, alicuotas){
        this.id = id;
        this.tipo = tipo;
        this.numero = numero;
        this.cliente_tipo_doc = cliente_tipo_doc;
        this.cliente_num_doc = cliente_num_doc;
        this.fecha = fecha;
        this.importe_total = importe_total;
        this.importe_neto = importe_neto;
        this.importe_iva = importe_iva;
        this.comprobante_asociado = comprobante_asociado;
        this.cae = cae;
        this.vencimiento_cae = vencimiento_cae;
        this.resultado = resultado;
        this.pedido = pedido;
        this.cliente = cliente;
        this.detalles = detalles;
        this.alicuotas = alicuotas;
    }
}
export default Comprobante;